<template>
  <header-app back="true" titlepage="یزد گیشه - لیست سانس"></header-app>
  <v-main class="main">
    <div class="col-12  float-right item" v-for="(cat, index)  in program" :key="index">
      <div>
        <div class="col-3 float-right">
          <img :src="cat.iconPro" width="100%">
        </div>
        <div class="col-9 divItem float-right">
          <h4 >{{ cat.namePro }}</h4>
          <v-divider/>
          <h4> {{cat.dateTime}}</h4>
          <v-divider/>
          <h4> {{cat.statusText}}</h4>
          <v-divider/>
          <h4> فروش گیشه : {{cat.gisheOrder}}</h4>
          <v-divider/>
          <h4> میمهان : {{cat.mihOrder}}</h4>
          <v-divider/>
          <h4> غیرفعال : {{cat.disable}}</h4>
          <v-divider/>
          <h4> فروش آنلاین : {{cat.siteOrder}}</h4>
          <v-divider/>
          <h4>مبلغ : {{cat.price}}</h4>
        </div>
      </div>
    </div>
    <div style="padding: 10px;text-align: center;color: #fff;direction: rtl" v-if="isLoading">
    <h2 >در حال دریافت اطلاعات ....</h2>
    <v-progress-circular
        color="green"
        class="loading"
        indeterminate
    ></v-progress-circular>
    </div>
  </v-main>
  <footer-app selectedItem="1"></footer-app>
</template>


<script >


import {defineComponent} from "vue";
import HeaderApp from "@/views/headerApp.vue";
import FooterApp from "@/views/FooterApp.vue";
import DataView from "@/views/DataView.vue";
import router from "@/router";
import http from "@/plugins/axios";
import {CurvedBottomNavigation} from "bottom-navigation-vue";
import {th} from "vuetify/locale";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';

export default {
  name: 'sans-view',
  components: { DataView, FooterApp, HeaderApp,Loading },
  data: () => ({
    program :  [],
    page : 0,
    get_next_page: false,
    length : 10,
    program_id : 0,
    isLoading : false,
    fullPage : true
  }),
  methods: {
    getData(pages) {
      const AuthStr = (localStorage.getItem("token"));
      this.isLoading = true;
      http.post("/getSans.php",{
            length : this.length,
            start : pages,
            program_id : this.$route.params.program_id
          },
          { headers: { Token: AuthStr } })
          .then(response => {
            this.isLoading = false;
            if(response.data!="200"){
              let dataP = response.data;
              this.urlUpload = response.data.urlUpload;
              dataP.massege.forEach((item) => {
                this.program.push(item);
              });
              this.get_next_page = true;
            }else{
              // alert("1");
            }

          });
    },
    fetchNextProducts() {
      window.onscroll = () => {

        let bottomOfWindow = $(window).scrollTop() + $(window).height() - $(document).height();

        if (bottomOfWindow > this.diffFromBottom) {

          // console.log(bottomOfWindow);
          // console.log(this.diffFromBottom);
          if (this.get_next_page) {
            this.get_next_page = false;
            this.page++;
            this.getData(this.page);
          }
        }
      }
    },
  },
  computed: {
    diffFromBottom() {
      let diff = -1200;
      diff = -1900;
      return diff;
    },
  },
  mounted() {
    this.getData();
    this.fetchNextProducts();
  },
}
</script>



<style scoped>
  .item{
    padding: 10px;
    text-align: right;
    direction: rtl;

  }
  .divItem h2{
    padding-top: 10px;
  }
  .item div{
    overflow: hidden;
    border-radius: 10px;
    border: 2px solid #e8e8e8;
    background: #e8e8e8;
  }
  h4{
    font-size: 10pt;
  }
</style>